import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/api.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  ticket:true,//票务相关是否更新
	  moneytotal:true,//财务相关是否更新
	  writeofftotal:true,//核销相关更行
	  agenttotal:true,//旅行社更新
	  yuyuetotal:true,//预约更新
	  compliantotal:true,//投诉更新
	  seetotal:true,//浏览量更新
	  setting:true,//系统配置更新
	  permissions: [],//权限列表
	  screencontent:true,//屏幕内容更新
	  warnuser:true,//屏幕内容更新
	  warndata:false,//屏幕内容更新
  },
  mutations: {
	  changeTicket(state, value){
		  state.ticket = value;
	  },
	  changeMoneytotal(state, value){
		  state.moneytotal = value;
	  },
	  changeWriteofftotal(state, value){
		  state.writeofftotal = value;
	  },
	  changeAgenttotal(state, value){
		  state.agenttotal = value;
	  },
	  changeYuyuetotal(state, value){
		  state.yuyuetotal = value;
	  },
	  changeCompliantotal(state, value){
		  state.compliantotal = value;
	  },
	  changeSeetotal(state, value){
		  state.seetotal = value;
	  },
	  changeSetting(state, value){
		  state.setting = value;
	  },
	  changePermissions(state, value){
		  state.permissions = value;
	  },
	  changeScreencontent(state, value){
		  state.screencontent = value;
	  },
	  changeWarnuser(state, value){
		  state.warnuser = value;
	  },
	  changeWarndata(state, value){
		  state.warndata = value;
	  },
	  
  },
  actions: {
	  GetInfo({ commit, state }) {
	    return new Promise((resolve, reject) => {
			api.postData("api/user/getInfo", {}).then(res => {
				if(res.code == 0){
					commit("changePermissions", JSON.parse(res.data.role));
					resolve(res);
				}else{
					reject(res)
				}
			}).catch(error => {
				reject(error)
			})
	    })
	  },
  }
})
